// Copyright (c) 2025 Deere & Company

import t from 'tcomb';

const DealerRecommendationConfirmModal = t.struct({
    actionToTake: t.String,
    isVisible: t.Boolean
}, 'DealerRecommendationConfirmModal');

export const getDefaultState = () =>
    new DealerRecommendationConfirmModal({
        actionToTake: '',
        isVisible: false
    });

export default DealerRecommendationConfirmModal;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/state/dealer-recommendation-confirm-modal.js